import { SearchParams } from "@customTypes/SearchParam";
import { TableConfig } from "interfaces/config";
import { ReactNode } from "react";
import { create } from "zustand";
import { createJSONStorage, persist } from 'zustand/middleware';
import { initialState } from "../customTypes";
import { ColumnState, ConfigServiceState } from "../interfaces";
import {
    Pagination
} from "./interfaces";
import { columnVisibilityReducer } from "./reducers/columnVisibilityReducer";

function clone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}

export const useTableStore = create(
    persist(
        (set, get) => ({
            ...clone(initialState),
            columnState: {
                ...clone(initialState).columnState,
            },
            setDisableButton: (disableButton: number) => set({ disableButton }),

            setZoomLevel: (zoomLevel: number) => set({ zoomLevel }),
            columnStateDispatch: args => set(state => columnVisibilityReducer(state, args)),
            setRunFilters: (runFilters: boolean) => set({ runFilters }),
            setFiltersAppliedByTable: (tableName: string, filtersApplied: boolean) => set((state) => ({
                filtersAppliedByTable: { ...state.filtersAppliedByTable, [tableName]: filtersApplied }
            })),
            filtersAppliedByTable: {},
            appliedFiltersByTable: {},
            setAppliedFiltersByTable: (tableName: string, appliedFilters: any[]) => set((state) => ({
                appliedFiltersByTable: { ...state.appliedFiltersByTable, [tableName]: appliedFilters }
            })),
            setUserActive: (userActive: boolean) => set({ userActive }),
            setButtonCellHandlers: (buttonCellHandlers: any) => set({ buttonCellHandlers }),
            setTableConfig: (tableConfig: TableConfig) => set({ tableConfig }),
            setInternalSearchArray: (internalSearchArray: any) => set({ internalSearchArray }),
            setPageName: (pageName: string) => set({ pageName }),
            setActionsConfig: (actionsConfig: { actionIcon?: ReactNode, actionLabel: string, actionHandler: Function }[]) => set({ actionsConfig }),
            setSelected: (selected) => set({ selected }),
            setTcns: (tcns: Array<any>) => set({ tcns }),
            setDisplayNoSearchResults: (displayNoSearchResults) => set({ displayNoSearchResults }),
            setPage: (page) => set({ page }),
            setRowsPerPage: (rowsPerPage) => set({ rowsPerPage }),
            setCurrentRow: (currentRow) => set({ currentRow }),
            setCustomFilterAnchorEl: (customFilterAnchorEl: null | HTMLElement) => set({ customFilterAnchorEl }),
            setCurrentCell: (currentCell: string | undefined) => set({ currentCell }),
            setCurrentDataIndex: (currentDataIndex: string) => set({ currentDataIndex }),
            setConfigService: (configService: ConfigServiceState) => set({ configService }),
            setPagination: (pagination: Pagination) => set({ pagination }),
            handleSortRequest: (tableName, property) => set((state) => {
                const current = state.pagination[tableName]
                return {
                    pagination: {
                        ...state.pagination,
                        [tableName]: {
                            ...current,
                            orderBy: property,
                            order: current.orderBy === property && current.order === "asc" ? "desc" : "asc"
                        }
                    }
                }
            }),
            resetTable: () => { },
            setResetTable: (resetTable: Function) => set({ resetTable }),
            setColumnState: (columnState: ColumnState) => set({ columnState }),
            setComponent: (componentConfig: any) => set({ componentConfig }),
            setHeaderButtonConfig: (headerButtonConfig: any) => set({ headerButtonConfig }),
            setSearchParams: (searchParams: SearchParams) => set({ searchParams }),
            setIsDelete: (isDelete: boolean) => set({ isDelete }),
            setConfigFile: (configFile: string) => set({ configFile }),
            setConfigBody: (configBody: any) => set({ configBody }),
            setIsPost: (isPost: boolean) => set({ isPost }),
            setSimpleSearchRan: (simpleSearchRan: boolean) => set({ simpleSearchRan }),
            resetTableState: () => set((state) => ({
                pagination: {
                    ...clone(initialState).pagination
                },
                searchParams: [],
                simpleSearchRan: false,
                displayNoSearchResults: false
            })),
            resetTableStore: () => set(state => ({
                ...state,
                ...clone(initialState),
                columnStateDispatch: args => set(state => columnVisibilityReducer(state, args)),
            })),
            resetTablePaginationByTableName: (tableName) => set((state) => ({
                pagination: {
                    ...state.pagination,
                    [tableName]: {
                        ...clone(initialState).pagination[tableName]
                    }
                }
            }))
        }),
        {
            name: "tableStore",
            storage: createJSONStorage(() => sessionStorage),
            partialize: (state: any) => {
                return { tableConfig: state.tableConfig, columnState: state.columnState, pagination: state.pagination }
            },
            merge: (persistedState: any, currentState) => {
                console.log('tableStore merge function: ', { persistedPagination: persistedState.pagination["reject-codes"], currenPagination: currentState.pagination["reject-codes"] })
                return { ...currentState }
            },
        }
    )
)
